import { atom } from 'jotai';
import { cloneDeep } from 'lodash-es';
import type { AutomationWizardControllerState } from 'modules/Settings/Automation/pages/AutomationWizard/controller/types';
import { clone } from 'remeda';

import type {
  AutomationAction,
  AutomationCondition,
  CreateAutomationVariables,
} from '../../../api';

const INITIAL_CONDITION: AutomationCondition = {
  fieldName: null,
  operator: null,
  operand: null,
};

const INITIAL_ACTION: AutomationAction = {
  type: null,
};

const AUTOMATION_WIZARD_INITIAL_STATE: AutomationWizardControllerState = {
  step: {
    current: 0,
    highestVisited: 0,
  },
};

const AUTOMATION_FORM_INITIAL_VALUES: CreateAutomationVariables = {
  name: '',
  description: null,
  targetModel: 'invoice',
  active: true,
  triggers: [],
  conditions: [clone(INITIAL_CONDITION)],
  actions: [clone(INITIAL_ACTION)],
};

export function getEmptyCondition(): AutomationCondition {
  return { ...clone(INITIAL_CONDITION) };
}

export function getEmptyAction(): AutomationAction {
  return { ...clone(INITIAL_ACTION) };
}

export function getAutomationWizardInitialState(): AutomationWizardControllerState {
  return cloneDeep(AUTOMATION_WIZARD_INITIAL_STATE);
}

export function getAutomationFormInitialValues(): CreateAutomationVariables {
  return cloneDeep(AUTOMATION_FORM_INITIAL_VALUES);
}

export const automationWizardStateAtom = atom(getAutomationWizardInitialState());
